module.exports = __webpack_public_path__ + "static/img/error.57913130.png";